import React, { useState, useMemo } from 'react';
import { Select } from '../ui-kit';
import lodash from 'lodash';

const filterOption = (op, filterValue) => op.data.textLabel.toLowerCase().includes(filterValue.toLowerCase());

const customStyles = {
  menuList: base => ({
    ...base,
    height: 190
  })
};

const ActivityTypeSelector = ({ activityTypes, selectedActivityTypes, handleChange, inputName, appliesTo }) => {
  // activityTypes can either be an array of types or an object (ID => type)
  activityTypes = Array.isArray(activityTypes) ? activityTypes : Object.values(activityTypes);
  if (appliesTo) activityTypes = activityTypes.filter(i => i.applies_to === appliesTo);
  activityTypes = lodash.sortBy(activityTypes, ['name']);

  // types can either be encoded as an array of ids, or an array of objects
  let [selectedActivityTypeIds, setSelectedActivityTypeIds] = useState(selectedActivityTypes.map(t => t.id || t));

  // two modes: controlled and uncontrolled. If controlled, it uses
  // selectedActivityTypes and handleChange. If uncontrolled, it uses the local
  // state and setSelectedActivityTypeIds
  if (handleChange === undefined) {
    handleChange = events => {
      if (!Array.isArray(events)) events = [events].filter(Boolean);
      const values = events.map(e => e.value);
      const activityTypeIds = new Set(activityTypes.map(t => t.id));
      const selectedIds = values.filter(v => activityTypeIds.has(v));
      setSelectedActivityTypeIds(selectedIds);
    };
  } else {
    // controlled: we use the props instead of the local state to find out which
    // activity types are selected
    selectedActivityTypeIds = selectedActivityTypes.map(t => t.id || t);
  }

  const options = useMemo(
    () =>
      activityTypes.map(t => {
        const textLabel = t.name;
        const label = (
          <div style={{ maxHeight: '40px', overflow: 'hidden', whiteSpace: 'nowrap' }}>
            <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              <span>{textLabel}</span>
            </div>
          </div>
        );
        return { value: t.id, textLabel, label };
      }),
    [activityTypes]
  );

  const selectedOptions = options.filter(o => selectedActivityTypeIds.find(id => id === o.value));

  // This component will be rendered (for now) as part of a normal HTML form. To
  // make sure this works, we create a hidden normal input field with a value
  // equal to the currently selected activity types
  return (
    <>
      {selectedActivityTypeIds.map(id => (
        <input key={id} type="hidden" name={inputName} value={id} />
      ))}
      <Select
        styles={customStyles}
        value={selectedOptions}
        onChange={handleChange || handleChange}
        options={options}
        isMulti={true}
        isClearable={true}
        isSearchable={true}
        className="react-select activity-types"
        placeholder={I18n.t('none')}
        filterOption={filterOption}
      />
    </>
  );
};

export default ActivityTypeSelector;
